<template>
    <el-container class="mainXxcxBody">
        <el-col class="box">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="mainTitle">房地产经纪机构备案查询</span>
                    <span class="zsText">注：输入条件房地产经纪机构名称或备案编号</span>
                </div>
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-row>
                        <el-form-item label="房地产经纪机构名称">
                            <el-input v-model="formInline.dwmc" placeholder="输入房地产经纪机构名称(可模糊查询)"></el-input>
                        </el-form-item>
                        <el-form-item label="备案编号">
                            <el-input v-model="formInline.babh" placeholder="输入备案编号"></el-input>
                        </el-form-item>
                        <span class="cxzxClass1">
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="resetHt">重置</el-button>
                            </el-form-item>
                        </span>
                    </el-row>
                </el-form>
            </el-card>
            <div v-show="sfxs_ht">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="mainTitle">查询结果</span>
                    </div>
                    <div>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    备案编号：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.BABH}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    机构名称：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.JGMC}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    统一社会<br>信用代码：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.TYSHXYDM}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    法定代表人<br>/负责人：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.FRDB}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    经营场所：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.JYCS}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    有效期限：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.YXQX}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    是否年审：
                                </span>
                                <span class="qfhHcontent2">
                                    {{jjjgccxjg.FSNS}}
                                </span>
                            </el-col>
                        </el-row>
<!--                        <el-row class="xkdzht" v-show="true">-->
<!--                            <el-button type="primary" @click="openHT">查看备案证书</el-button>-->
<!--                            <el-row>-->
<!--                                    <span>-->
<!--                                    （电子合同只限于2021年3月15日后通过汉中市房产交易管理系统电子签署服务平台与开发企业签署的电子合同方可查看）-->
<!--                                </span>-->
<!--                            </el-row>-->
<!--                        </el-row>-->


                    </div>
                </el-card>
            </div>
        </el-col>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        data() {
            return {
                formInline: {
                    dwmc: '',
                    babh: '',
                },
                sfxs_ht:false,

                jjjgccxjg:{},
                /*jjjgccxjg: {
                    dwmc: '未来房地产公司',
                    zjlb: '营业执照',
                    zjhm: '11029227712',
                    zzdj: '以及',
                    zzzs:'39833',
                    frdb: '李思达',
                    cyrs:'796',
                    jyfw:'房地产',
                    lxfs:'029-29281982',
                    dz:'未来城平安区'
                },*/
                reverse: true,
                value: ''
            }
        },
        methods: {
            ...mapActions([
                'HtxxSelect',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                if( (this.formInline.dwmc !=""||this.formInline.dwmc !="") || (this.formInline.babh !=""||this.formInline.babh !="")  ){
                    this.HtxxSelect({_module:'TT',_method:'getDwxx',dwmc:this.formInline.dwmc,babh:this.formInline.babh,dwlb: 42}).then((res) => {
                        if (res._result.DwxxList !=null ) {
                            /*业务信息list*/
                            this.jjjgccxjg=res._result.DwxxList;
                            this.sfxs_ht=true;
                        }else{
                            this.warnMessage("没有查到信息，请检查单位名称")
                        }
                    })
                }else{
                    this.warnMessage("查询条件不能为空");
                }
            },
            resetHt(){
                this.formInline.dwmc='';
                this.formInline.babh='';
                this.sfxs_ht=false;
            },
            openHT() {
                console.log(this.jjjgccxjg.BABH);
                const htUrl = 'http://127.0.0.1:8791/api/downloadDocument?ywbh=' + this.jjjgccxjg.BABH;
                window.open(htUrl, '_blank');
            }
        }
    }
</script>
<style>
    @import "../../assets/css/xxcx/xxcx_main.css";
</style>

